import {Modal} from "antd";

import AtomicTitle from "../AtomicTitle";
import './index.css';
import {useCallback, useEffect} from "react";

const AtomicPopup = ({
  open,
  onOk,
  title,
  children,
  headerStyle,
  titleStyle,
  bodyStyle,
  ...restProps
}) => {
  const handleKeyDown = useCallback((event) => {
    if (event.key === 'Enter' && open) {
      onOk && onOk();
    }
  }, [open]);

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);

  return (
    <Modal
      open={open}
      onOk={onOk}
      className="vlink-modal"
      {...restProps}
      styles={{
        header: {
          borderBottom: '1px solid #DCDCDC',
          padding: '20px 24px',
          ...headerStyle, // 사용자 정의 padding 병합
        },
        body: {
          backgroundColor: "#FFFFFF",
          padding: '0 24px',
          ...bodyStyle, // 사용자 정의 padding 병합
        }
      }}
      title={title && <AtomicTitle level={3} style={titleStyle}>{title}</AtomicTitle>}
    >
      <div>{children}</div>
    </Modal>
  );
};

export default AtomicPopup;
